import React from 'react'

import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import { LoadingSpin } from './components/LoadingSpin'
import { Text } from './constants/TextConstants'
import { Audit } from './components/Audit'
import { EditProfile } from './components/EditProfile'
import { Home } from './components/Home'
import { NotFound } from './components/NotFound'
import { Forbidden } from './components/Forbidden'
import ReleaseNotes from './components/ReleaseNotes'
import { Profiles } from './components/Profiles'
import { ViewProfile } from './components/ViewProfile'
import { Hobbies } from './components/ListManagement/Modals/Hobbies'
import { Certifications } from './components/ListManagement/Modals/Certifications'
import { Databases } from './components/ListManagement/Modals/Databases'
import { EducationalBackground } from './components/ListManagement/Modals/EducationalBackground'
import { IndustrySector } from './components/ListManagement/Modals/IndustrySector'
import { IndustryVerticals } from './components/ListManagement/Modals/IndustryVerticals'
import { LanguageLevel } from './components/ListManagement/Modals/LanguageLevel'
import { Languages } from './components/ListManagement/Modals/Languages'
import { ProgrammingLanguages } from './components/ListManagement/Modals/ProgrammingLanguages'
import { SoftSkills } from './components/ListManagement/Modals/SoftSkills'
import { TechnicalSkills } from './components/ListManagement/Modals/TechnicalSkills'
import { ToolsAndTechniques } from './components/ListManagement/Modals/ToolsAndTechniques'
import { TechnicalLevels } from './components/ListManagement/Modals/TechnicalLevels'
import { Users } from './components/Users'
import { Roles } from './components/Roles'

export const router = ({
  isLoading,
  editListPermission = false,
  editRolesPermission = false,
  assignRolesPermission = false,
  viewMyTeamPagePermission = false,
  isAuthenticated
}) => {
  const spin = <LoadingSpin loadingText={Text.GenericLoading} />
  return createBrowserRouter(
    createRoutesFromElements(
      <Route path='/' element={isAuthenticated ? <Home /> : <></>} errorElement={<NotFound />}>
        <Route index={true} element={isAuthenticated ? <Navigate to='/view' replace /> : <></>} />
        <Route path='view/:userId?' element={<ViewProfile />} />
        <Route path='edit/:userId?' element={<EditProfile hideEditButton={false} />} />
        <Route path='audit/:userId?' element={<Audit />} />
        <Route path='hobbies' element={isLoading ? spin : editListPermission ? <Hobbies /> : <Forbidden />} />
        <Route
          path='certifications'
          element={isLoading ? spin : editListPermission ? <Certifications /> : <Forbidden />}
        />
        <Route path='databases' element={isLoading ? spin : editListPermission ? <Databases /> : <Forbidden />} />
        <Route
          path='educational-background'
          element={isLoading ? spin : editListPermission ? <EducationalBackground /> : <Forbidden />}
        />
        <Route
          path='industry-sector'
          element={isLoading ? spin : editListPermission ? <IndustrySector /> : <Forbidden />}
        />
        <Route
          path='industry-verticals'
          element={isLoading ? spin : editListPermission ? <IndustryVerticals /> : <Forbidden />}
        />
        <Route
          path='language-level'
          element={isLoading ? spin : editListPermission ? <LanguageLevel /> : <Forbidden />}
        />
        <Route path='languages' element={isLoading ? spin : editListPermission ? <Languages /> : <Forbidden />} />
        <Route
          path='programming-languages'
          element={isLoading ? spin : editListPermission ? <ProgrammingLanguages /> : <Forbidden />}
        />
        <Route path='soft-skills' element={isLoading ? spin : editListPermission ? <SoftSkills /> : <Forbidden />} />
        <Route
          path='technical-skills'
          element={isLoading ? spin : editListPermission ? <TechnicalSkills /> : <Forbidden />}
        />
        <Route
          path='tools-techniques'
          element={isLoading ? spin : editListPermission ? <ToolsAndTechniques /> : <Forbidden />}
        />
        <Route
          path='technical-levels'
          element={isLoading ? spin : editListPermission ? <TechnicalLevels /> : <Forbidden />}
        />
        <Route path='profiles' element={isLoading ? spin : viewMyTeamPagePermission ? <Profiles hideEditButton={false} /> : <Forbidden />} />
        <Route
          path='roles-assignment'
          element={editRolesPermission || assignRolesPermission ? <Users /> : <Forbidden />} />
        <Route
          path='roles'
          element={editRolesPermission || assignRolesPermission ? <Roles /> : <Forbidden />} />
        <Route path='release-notes' element={<ReleaseNotes />} />
        <Route path='forbidden' element={<Forbidden />} />
      </Route>
    )
  )
}
